import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { convertSettingStyle2ComponentStyle } from 'client/styles/common';

export default function usePromoSettingComponentStyle() {
    const settingStyle = useSelector(s => s.settingStyle);
    return useMemo(() => convertSettingStyle2ComponentStyle(settingStyle), [settingStyle]);
}
